import { useContext } from "react"
import OrderOverviewPersonalDetails from "./personal-details/personal-details"
import OrderOverviewBillingData from "./billing-data/billing-data"
import OrderOverviewSelectedModules from "./selected-modules"
import CheckoutContext from "../../checkout-context"

export function OrderOverview({ hasBillingInfoChangeLink = true }) {
  const {
    data: checkoutData,
    cartLineItems,
    customerData,
    textsMapping,
    goToStep,
    hasModuleScheduler,
  } = useContext(CheckoutContext)

  const { sectors, countries, genders } = checkoutData

  return (
    <section className="checkout-section order-overview">
      <h2>{textsMapping.orderOverviewTitle}</h2>

      <OrderOverviewPersonalDetails
        textsMapping={textsMapping}
        customerData={customerData}
        genders={genders}
        countries={countries}
        sectors={sectors}
        goToStep={goToStep}
        hasModuleScheduler={hasModuleScheduler}
      />

      <OrderOverviewBillingData
        textsMapping={textsMapping}
        customerData={customerData}
        genders={genders}
        countries={countries}
        goToStep={goToStep}
        hasModuleScheduler={hasModuleScheduler}
        hasBillingInfoChangeLink={hasBillingInfoChangeLink}
      />

      {hasModuleScheduler && (
        <OrderOverviewSelectedModules
          textsMapping={textsMapping}
          cartLineItems={cartLineItems}
          goToStep={goToStep}
        />
      )}
    </section>
  )
}
